import { render, staticRenderFns } from "./Ear-protection-experts.vue?vue&type=template&id=35a1af48&"
import script from "./Ear-protection-experts.vue?vue&type=script&lang=js&"
export * from "./Ear-protection-experts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports